import React from 'react';
import { IPostalAddress } from '../../services/WebApiClient';
import { State } from '../../util/useState2';
import { PostalAddressEditorField } from './PostalAddressEditorField';


export function PostalAddressEditor(props: {
    postalAddress: State<IPostalAddress>;
    disabled: boolean;
}) {

    return (
        <div>
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Sags-ID"
                propName="caseId"
                htmlType="text"
                disabled={false}
                required={false}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Navn"
                propName="name"
                htmlType="text"
                disabled={props.disabled}
                required={!props.disabled}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Adresse"
                propName="address1"
                htmlType="text"
                disabled={props.disabled}
                required={!props.disabled}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Adresse 2"
                propName="address2"
                htmlType="text"
                disabled={props.disabled}
                required={false}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Postnummer"
                propName="postalCode"
                htmlType="text"
                disabled={props.disabled}
                required={!props.disabled}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="By"
                propName="city"
                htmlType="text"
                disabled={props.disabled}
                required={!props.disabled}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Land"
                propName="country"
                htmlType="text"
                disabled={props.disabled}
                required={!props.disabled}
            />
            <PostalAddressEditorField address={props.postalAddress}
                defaultName="Telefonnummer"
                propName="phone"
                htmlType="tel"
                disabled={props.disabled}
                required={!props.disabled}

            />
        </div>
    );
}
